<!--
  Popup "self-assign this shift" details. Normally the contents of a modal dialog
-->
<template>
  <p>You can't "undo" this action, so please check the date and time</p>
  <b-card>
    <h4>{{ formatRotaStartDateLong(selfAssign.shift.startDate) }}</h4>
    <span class="badge rounded-pill self-assign">
      {{ formatDistanceToNow(selfAssign.shift.startDate, { addSuffix: true }) }}
    </span>
    <rota-agenda-shift-view
      :rota-type="rota.type"
      :rota-status="rota.status"
      :rota-id="rota.id"
      :shift="selfAssign.shift"
      :user-id="user.id"
      :always-expanded="true"
      :hide-assigned="true"
    />
  </b-card>
  <b-alert
    :model-value="selfAssign.errorMessage.length > 0"
    variant="warning"
    class="my-2"
  >
    <font-awesome-icon icon="exclamation-circle" />
    {{ selfAssign.errorMessage }}
  </b-alert>
</template>

<script>
import { formatDistanceToNow } from "date-fns";
import { useAuthStore } from "@switchsystems/coactive-vue-lib";
import RotaAgendaShiftView from "@/components/rota/agenda/RotaAgendaShiftView.vue";
import { formatRotaStartDateLong } from "@/lib/date-functions";
import { storeToRefs } from "pinia";

export default {
  name: "SelfAssignRotaShiftPopup",
  components: {
    RotaAgendaShiftView,
  },
  props: {
    rota: {
      type: Object,
      required: true,
    },
    selfAssign: {
      type: Object,
      default: () => ({
        visible: false, // whether the modal dialog should be shown or not
        check: false, // checkbox to say "yes i want to self assign this shift"
        shift: {}, // the shift that we want to self-assign
        busy: false, // whether the modal should be in a busy state or not
        errorMessage: "", // any errors encountered
      }),
    },
  },
  setup() {
    const authStore = useAuthStore();
    const { user } = storeToRefs(authStore);
    return {
      user,
      formatRotaStartDateLong,
      formatDistanceToNow,
    };
  },
};
</script>
